<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Pedidos
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa" 
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
              <!-- Tipo -->
            <div class="col-sm-12" style="margin-top: 10px">
              <label class="col-sm-6">Maquina</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="vendMachine"
              >
                <el-option
                  v-for="maq in machines"
                  class="select-danger"
                  :value="maq.id"
                  :label="maq.location"
                  :key="maq.id"
                ></el-option>
              </el-select>
            </div>
             
              <!-- (des)Ativado -->
            <div class="col-sm-12">
              <label class="col-sm-6">Status</label>
              <el-select
                class="select-default col-sm-12"
                size="large"
                placeholder="Selecione"
                v-model="statusCupom"
              >
                <el-option
                  v-for="option in status"
                  class="select-danger"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </div>
           
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width" v-if="showTable">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
          <el-table-column label="ID" prop="id" />
          <el-table-column label="Sys_ID" prop="sys_id" width="180" sortable='custom'/>
            <el-table-column label="VM" property="vm_location" width="220" />
            <el-table-column label="Quantidade" property="quantity" min-width="180"/>
            <el-table-column label="Nota" width="160" >
              <template slot-scope="scope">
                <el-rate v-model="scope.row.grade" :colors="colorido"></el-rate> 
              </template>
            </el-table-column>
            <el-table-column label="Status" property="status" width="340" />
            
          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Tooltip,
  Tag,
  Rate,
  Loading
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    [Rate.name]: Rate,
  },
  data () {
    return {
      filtro: false,
      produto: [],
      tipo: [],
      prateleira: [],
      vendMachine: [],
      date_init: [],
      categories: [],
      category: '',
      vouchers: [],
      colorido: ['green', 'yellow', '#FF9900'],
      valido: [{label: 'Categoria', value: 'only_category'},
               {label: 'Produto', value: 'only_product'}, 
               {label: 'Toda empresa', value: 'total'}, ],
      validoEm: '',
      status: [{label: 'Entregue', value: 'ENT'},
               {label: 'Aguardando', value: 'AGU'} ],
      statusCupom: '',
      products: [],
      machines: [],
      showTable: true,
      vouchersAPI: [],
      totalResults: 30,
      pesquisa: '',
      page: 1,
      pageSize: 10,
      order: false,
      loading: true,
      btnLoading: false,
      sord: '',
    }
  },
  created() {
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted () {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany
  },
  computed: {
    
    tableData() {
      console.log('store', this.$store.state)
      const orders = this.$store.state.order.orders
      const populated = orders.map(v => {
        let status , cor, grade

        if (v.status == 'AGU') {
          status = 'Aguardando'
          cor = 'orange'
        }
        if (v.status == 'ENT') {
          status = 'Entregue'
          cor = 'green'
        }
        if (v.grade) {
          grade = Number(v.grade)
        }

        return { ...v, status, cor, grade };
      })
      return populated
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    productsName() {
      return this.$store.state.products.products;
    },
  },
  methods: {
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === "grade") {
        x.prop = 'grade'
      }
      
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filtragem () {
      this.vouchers = this.vouchersAPI
      var date = []
      this.pesquisa = ''

      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.pesquisa = this.pesquisa + '&company=' + ciaID
      }

      if (this.vendMachine) {
        this.pesquisa = this.pesquisa + "&vm=" + this.vendMachine
      }

      if (this.statusCupom) {
        this.pesquisa = this.pesquisa + "&status=" + this.statusCupom
      }
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.filtro = false;
    },
    clearFiltro() {
      this.produto = "";
      this.statusCupom = ''
      this.category = ''
      this.validoEm = ''
      this.tipo = "";
      this.prateleira = "";
      this.vendMachine = "";
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      this.date_init = []
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    filterTag(value, row) {
      return row.ativo === value;
    },
    filterTag2(value, row) {
      return row.limit === value;
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    getData (id) {
      this.loading = true
      if (id) { 
        id = id
      } else {
        id = ''
      }

      this.$store.dispatch("order/listSort", {sort: '?page_size=' + this.pageSize
        + '&page=' + this.page + '&company=' + id +
        '&ordering=' + this.sord + this.pesquisa}).then(resp => {
        this.totalResults = this.$store.state.order.page.count
        this.loading = false
      }).catch(err => console.log(err));
      this.$store.dispatch("machines/listSort",{sort: '?page_size=300'  + '&company=' + id}).then(data =>{
        this.machines = data
      })
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
